import { render, staticRenderFns } from "./roomContracts.vue?vue&type=template&id=23a788f0&scoped=true"
import script from "./roomContracts.vue?vue&type=script&lang=js"
export * from "./roomContracts.vue?vue&type=script&lang=js"
import style0 from "./roomContracts.vue?vue&type=style&index=0&id=23a788f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a788f0",
  null
  
)

export default component.exports